module.exports = __webpack_public_path__ + "img/altruistic-anniversaries.1f389f3a.png";